import React from 'react'

const sample = (Sentence) => {
    return (
        <div>
            {Sentence}     
        </div>
    )
}

export default sample
